(function () {
    const VB_WIDTH = 1626;
    const VB_HEIGHT = 103;
    const START_POINT = '0.142602 102.027';
    const END_POINT = '1625.92 93.0251';

    function alignWave(section) {
        const svg = section.querySelector('.steplist__bg');
        const ul = section.querySelector('.steplist__ul ul');
        if (!svg || !ul) return;

        const dots = ul.querySelectorAll(':scope > li > svg');
        if (dots.length < 3) return;

        if (window.innerWidth <= 992) return;

        const svgRect = svg.getBoundingClientRect();
        if (!svgRect.width || !svgRect.height) return;

        const points = [START_POINT];
        for (let i = 0; i < 3; i++) {
            const r = dots[i].getBoundingClientRect();
            const cx = r.left + r.width / 2 - svgRect.left;
            const cy = r.top + r.height / 2 - svgRect.top;
            const vbX = (cx / svgRect.width) * VB_WIDTH;
            const vbY = (cy / svgRect.height) * VB_HEIGHT;
            points.push(vbX.toFixed(3) + ' ' + vbY.toFixed(3));
        }
        points.push(END_POINT);

        const d = 'M' + points.join('L');
        svg.querySelectorAll('path').forEach((p) => p.setAttribute('d', d));
    }

    function updateAll() {
        document.querySelectorAll('.steplist').forEach(alignWave);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateAll);
    } else {
        updateAll();
    }
    window.addEventListener('load', updateAll);
    window.addEventListener('resize', updateAll);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateAll);
    }
})();
